export default {
  frontend_groovemember_left_panel_instructor_heading: 'Your Instructor',
  frontend_groovemember_left_panel_membership_outline_heading: 'Membership Outline',
  frontend_groovemember_left_panel_progress_bar_heading: '% Completed',
  frontend_groovemember_main_panel_add_comment: 'Add a new comment',
  frontend_groovemember_main_panel_comments_heading: 'Comments',
  frontend_groovemember_main_panel_previous_button: 'Previous',
  frontend_groovemember_main_panel_next_button: 'Mark As Complete',
  frontend_groovemember_top_navbar_profile_dropdown_hey: 'Hey',
  frontend_groovemember_top_navbar_profile_dropdown_level: 'Level',
  frontend_groovemember_top_navbar_profile_dropdown_settings: 'Settings',
  frontend_groovemember_top_navbar_profile_dropdown_back_to_portal: 'Back to Portal',
  frontend_groovemember_top_navbar_profile_dropdown_logout: 'Logout',
  frontend_groovemember_course_edit_access_now:'Access Now',
  frontend_groovemember_course_edit_learn_more:'Learn More',
  frontend_instructors: 'Instructors',
  frontend_content: 'Content',  
  frontend_groovemember_form_password: 'Password',
  frontend_groovemember_form_placeholder_email: 'Enter your email',
  frontend_groovemember_form_placeholder_password: 'Enter your password',
  frontend_groovemember_form_forgot_pass: 'Forgot your password',
  frontend_groovemember_form_back_to_home: 'Back to home',
  frontend_groovemember_form_signin: 'Sign In Now',
};
